/* EU-Gewährleistungslabel: öffnet/schließt das native <dialog>-Modal aus
   snippets/eu-warranty-label.liquid. Delegierte Listener, damit das Snippet
   beliebig oft im DOM vorkommen kann (Footer, Warenkorb, Cart-Drawer). */
(function () {
  if (window.euWarrantyLabelInitialized) return;
  window.euWarrantyLabelInitialized = true;

  function loadImage(dialog) {
    var img = dialog.querySelector('[data-eu-warranty-image]');
    if (img && !img.getAttribute('src')) {
      img.setAttribute('src', img.getAttribute('data-src'));
    }
  }

  function openDialog(trigger) {
    var targetId = trigger.getAttribute('data-eu-warranty-target');
    var dialog = targetId ? document.getElementById(targetId) : null;
    if (!dialog || typeof dialog.showModal !== 'function') return;

    loadImage(dialog);
    dialog.euWarrantyTrigger = trigger;
    document.body.classList.add('overflow-hidden');
    dialog.showModal();
  }

  function closeDialog(dialog) {
    if (dialog.open) dialog.close();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-eu-warranty-trigger]');
    if (trigger) {
      openDialog(trigger);
      return;
    }

    var closeButton = event.target.closest('[data-eu-warranty-close]');
    if (closeButton) {
      var ownerDialog = closeButton.closest('dialog[data-eu-warranty-dialog]');
      if (ownerDialog) closeDialog(ownerDialog);
      return;
    }

    // Klick auf den Backdrop: bei einem nativen <dialog> ist event.target das
    // <dialog>-Element selbst, sowohl beim echten Backdrop als auch bei einem
    // Klick auf sein eigenes (nicht von einem Kind ausgefülltes) Padding.
    // Deshalb zusätzlich per Koordinaten prüfen, ob der Klick wirklich außerhalb liegt.
    if (event.target.nodeName === 'DIALOG' && event.target.hasAttribute('data-eu-warranty-dialog')) {
      var rect = event.target.getBoundingClientRect();
      var clickedInside =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (!clickedInside) {
        closeDialog(event.target);
      }
    }
  });

  document.querySelectorAll('dialog[data-eu-warranty-dialog]').forEach(function (dialog) {
    dialog.addEventListener('close', function () {
      document.body.classList.remove('overflow-hidden');
      var trigger = dialog.euWarrantyTrigger;
      if (trigger && typeof trigger.focus === 'function') {
        trigger.focus();
      }
    });
  });
})();
